import { render, staticRenderFns } from "./DeleteMaterialModal.vue?vue&type=template&id=59c99dec&scoped=true&class=fill-height&"
import script from "./DeleteMaterialModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteMaterialModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteMaterialModal.vue?vue&type=style&index=0&id=59c99dec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c99dec",
  null
  
)

export default component.exports